export default function Step3() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="38" viewBox="0 0 34 38" fill="none">
            <path
                d="M12.1081 6.21289L13.5349 7.25369L15.301 7.25033L15.8436 8.93103L17.2744 9.96639L16.7254 11.645L17.2744 13.3236L15.8436 14.3589L15.301 16.0396L13.5349 16.0363L12.1081 17.0771L10.6813 16.0363L8.91522 16.0396L8.37266"
                stroke="white"
                strokeWidth="1.32"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.0432 14.1225L5.79472 18.017L5.04395 19.3174L6.54547 19.324L7.23367 19.3271L7.58043 19.9216L8.33698 21.2186L9.08775 19.9182L11.1362 16.3701L10.6788 16.0364L9.82259 16.038L8.3312 18.6212L7.98444 18.0267L7.29624 18.0237L8.74376 15.5165L8.37011 14.3591L8.0432 14.1225ZM13.099 16.3525L15.1577 19.9182L15.9085 21.2186L16.665 19.9216L17.0118 19.3271L17.7 19.324L19.2015 19.3174L18.4507 18.017L16.1921 14.105L15.841 14.3591L15.4797 15.4784L16.9492 18.0237L16.261 18.0267L15.9143 18.6212L14.4229 16.0381L13.5324 16.0364L13.099 16.3525Z"
                fill="white"
            />
            <rect x="3.14843" y="1.99707" width="28.4278" height="34.2291" rx="2.0642" stroke="white" strokeWidth="1.3037" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.2516 26.8767H13.7393V25.7686H21.2516V26.8767ZM21.2406 29.6471H13.7393V28.5389H21.2406V29.6471ZM21.2406 32.4174V31.3093H13.7393V32.4174H21.2406Z"
                fill="white"
            />
            <rect x="22.228" y="25.7683" width="7.37842" height="1.05011" fill="white" />
            <path d="M29.6064 29.6726H23.2823V31.0467V32.419H22.228V29.6726V28.5686H29.6064V29.6726Z" fill="white" />
            <circle cx="12.1105" cy="11.6449" r="1.90123" stroke="white" strokeWidth="1.08642" />
        </svg>
    );
}
